import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiButtonModule, TuiHintModule, TuiSvgModule } from '@taiga-ui/core';
import { map, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TuiAccordionModule } from '@taiga-ui/kit';
import { Store } from '@ngxs/store';
import { TuiLetModule } from '@taiga-ui/cdk';

import {
  TuiBadgedContentModule,
  TuiBadgeNotificationModule,
} from '@taiga-ui/experimental';

import { CargoCatalogsService } from '@shared/services/cargo-catalogs.service';
import { countPlacesAndSumPackages } from '@shared/utils/cargo-calculation';
import { CargoOrder } from '../../../../types/cargo';
import { OrderComponent } from './components/order/order.component';
import { CargoCalculationState } from '../../store/cargo-calculation.state';

type PreparedOrder = {
  original: CargoOrder;
  computed: {
    places: string;
    packages: number;
    flowerTypeName: string;
  };
};

@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [
    TuiButtonModule,
    AsyncPipe,
    TuiAccordionModule,
    TuiLetModule,
    TuiSvgModule,
    TuiBadgeNotificationModule,
    TuiBadgedContentModule,
    OrderComponent,
    TuiHintModule,
  ],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdersComponent {
  orders$ = this.store.select(CargoCalculationState.getOrders);

  preparedOrders$: Observable<PreparedOrder[]> = this.orders$.pipe(
    map(orders => {
      const flowerTypesMap = this.cargoCatalogsService.flowerTypesMap;
      return orders.map(order => {
        const { packages, places } = countPlacesAndSumPackages(order);
        return {
          original: order,
          computed: {
            packages,
            places,
            flowerTypeName:
              flowerTypesMap.get(order.flowerType ?? '')?.name ?? '',
          },
        };
      });
    }),
  );

  cargo$ = this.store.select(CargoCalculationState.getSelectedCargo);

  constructor(
    private readonly store: Store,
    private readonly cargoCatalogsService: CargoCatalogsService,
  ) {}
}
